import Model from 'flarum/common/Model';
export default class NewSpecies extends Model {
  gbifId() {
    return Model.attribute('gbifId').call(this);
  }
  parentGbifId() {
    return Model.attribute('parentGbifId').call(this);
  }
  parentScientificName() {
    return Model.attribute('parentScientificName').call(this);
  }
  canonicalName() {
    return Model.attribute('canonicalName').call(this);
  }
  author() {
    return Model.attribute('author').call(this);
  }
  rank() {
    return Model.attribute('rank').call(this);
  }
}
flarum.reg.add('champis-species', 'common/models/NewSpecies', NewSpecies);